import { Industry } from 'src/app/industryeditor/models/industry';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { ModelState } from '../../models/ModelState';
import { FunctionalityGroup } from '../../models/functionality-group';
import { IndustryFragment } from '../../models/industry-fragment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IndustryService {

  industries: Industry[] = [];
  searchedIndustry: string = "";
  searchFragment: string = "";
  private _selectedIndustry = new BehaviorSubject<ModelState<Industry> | null>(null);
  private _selectedIndustryAllVersions = new BehaviorSubject<Array<Industry> | null>(null);
  private _industryFragments = new BehaviorSubject<Array<IndustryFragment>>([]);
  public groups: FunctionalityGroup[];


  constructor() { }

  getSelectedIndustry() {
    return this._selectedIndustry.asObservable();
  }

  getCurrentSelectedIndustry() {
    return this._selectedIndustry.value;
  }

  AddNewVersionToSelectedIndustry(industry:Industry){
    let industries =  this.GetAllVersionsForSelectedIndustry();
    industries?.unshift(industry);
    this._selectedIndustryAllVersions.next(industries);
  }

  AddAllVersionsForSelectedIndustry(industries: Array<Industry>) {
      this._selectedIndustryAllVersions.next(industries);
  }
  GetAllVersionsForSelectedIndustry() {
    return this._selectedIndustryAllVersions.value;
}

  AddSelectedIndustry(industry: ModelState<Industry> | Industry | null) {

    if (industry instanceof ModelState && industry) {
      this._selectedIndustry.next(industry);
    } else if (industry) {
      let ms: ModelState<Industry> = new ModelState<Industry>(industry as Industry)
      this._selectedIndustry.next(ms);
    }else{
      this._selectedIndustry.next(null);
    }
  }

  getIndustryFragmentsGroupBy(searchFragment:string) {
    return this._industryFragments.asObservable().pipe(map(mf => {
      let filterFragments = this.filterFragments(mf,searchFragment);
      let mfeatures = this.updateWithExistingFragments(filterFragments);
      let groupedFragments = this.createFragmentTree(mfeatures);
      return groupedFragments;
    }));
  }

  filterFragments(mf: IndustryFragment[], searchFragment:string) : IndustryFragment[]{
      let fragments:IndustryFragment[] = [];
      fragments = mf?.filter(f => f.fragment.toLowerCase().includes(searchFragment.toLowerCase()));
      return fragments;
  }

  getUpdatedIndustryFragments() {
    //let mf = this.updateWithExistingFragments(this._industryFragments.value);
    return this._industryFragments.value
    //return mf;
  }

  getCurrentIndustryFragments() {
    let mf = this._industryFragments.value;
    return mf;
  }

  private createFragmentTree(iFragments: IndustryFragment[]) {
    let groupedFragments = this.groupFragments(iFragments);
    let treeFragments: IndustryFragment[] = groupedFragments;
    let parentGroupList;
    parentGroupList = treeFragments.filter(f => f.ParentGroup && !!f.Childrens && f.Childrens.length > 0);
    do {
      this.createGroupTree(treeFragments);
      parentGroupList = treeFragments.filter(f => f.ParentGroup && !!f.Childrens && f.Childrens.length > 0);
    }
    while (parentGroupList.length > 0)

    return treeFragments;

  }

  private createGroupTree(treeFragments:IndustryFragment[]) {
    treeFragments.forEach((element, index) => {
      if (!element.ParentGroup)
        return;
      let parentGroupFragment = treeFragments.find(f => f.Group == element.ParentGroup && !!f.Childrens && f.Childrens.length > 0);
      let pFragment = this.groupIntoParentGroup(parentGroupFragment, element);
      if (pFragment)
        treeFragments.push(pFragment);
      treeFragments.splice(index, 1);
    });
  }

  groupIntoParentGroup(parentGroupFragment: IndustryFragment | undefined, fragment: IndustryFragment) {
    if (!parentGroupFragment) {
      let group = this.groups.find(g => g.GroupCode = fragment.ParentGroup);
      let i = new IndustryFragment();
      i.Group = group!.GroupCode;
      i.ParentGroup = group!.ParentGroupCode;
      i.Childrens = [];
      i.Childrens.push(fragment);
      return i;
    }
    else {
      parentGroupFragment.Childrens.push(fragment);
      return null;
    }
  }

  groupFragments(fragments: IndustryFragment[]) {
    let sFragmetns: IndustryFragment[] = [];

    const map: Map<string, IndustryFragment[]> = new Map(Array.from(fragments, obj => [obj.Group, []]));
    fragments.forEach(obj => {
      map.get(obj.Group)?.push(obj)
    });
    map.forEach((value, key) => {
      if (!key) {
        sFragmetns.push(...value);
        return;
      }

      let f = new IndustryFragment();
      f.Group = key;
      f.ParentGroup = value[0].ParentGroup;
      f.Childrens = value
      sFragmetns.push(f)

    });

    return sFragmetns;
  }

  private updateWithExistingFragments(mf: IndustryFragment[]): IndustryFragment[] {
    let fragments: IndustryFragment[] = [];
    let selectedIndustry = this.getCurrentSelectedIndustry()
    if (!selectedIndustry)  return mf;
    mf.forEach(element => {
        let fragmentInSelectedIndustry = selectedIndustry!.Model.Manufacture.features?.find(fp => element.fragment == fp.fragment);
        if (fragmentInSelectedIndustry) {
          element.IsInIndustry = true;
          element.options = fragmentInSelectedIndustry.options
          fragments.push(element);
        } else {
          fragments.push(element);
        }
    });
    return fragments;
  }

  addIndustryFragment(fragment: IndustryFragment) {
    this._industryFragments.value.push(JSON.parse(JSON.stringify({...fragment})) as IndustryFragment);
  }

  addIndustryFragments(fragments: IndustryFragment[]) {
    return this._industryFragments.next(JSON.parse(JSON.stringify(fragments)) as IndustryFragment[]);
  }


}
